import React, {useContext} from 'react';
import { Link } from 'gatsby';
import IconLink from '~/components/IconLink';
import Image from '~/components/Dynamic/Image';
import TransContext from '~/contexts/TransContext';
import renderLink from '~/utils/render-link';

export default function FeaturedCustomerSection({ blok }) {
  const trans = useContext(TransContext);
  const reverse = blok.reverse;

  return blok ? (
    <section className="my-20 md:my-32">
      <div className="container">
        <Link to={renderLink(blok?.textCard[0]?.button[0]?.button?.cached_url)}>
          <div className="flex flex-wrap items-center -ml-16 md:pb-11">
            <div className={`w-full pl-16 md:w-6/12 ${reverse && 'md:order-1'}`}>
              <div className={`flex flex-col md:max-w-md ${reverse && 'md:mx-auto'}`}>
                <div className="mb-7">
                  <div className="h-[29px]">
                    <Image blok={blok.textCard[0].icon}  imageClassName="h-full !w-auto object-contain" className="object-contain object-left h-full"/>
                  </div>

                </div>
                <div className="mb-6">
                  <h3 className="font-bold leading-[1.18em] text-28px md:text-38px tracking-2 font-heading ">
                    {blok.textCard[0].heading}
                  </h3>
                </div>

                <IconLink color={'black'} type="button" className={`text-20px mb:mt-8`}>
                  {trans.content.readMore}
                </IconLink>

                <div className="leading-normal mt-11 text-20px font-heading opacity-80">
                  <p>{blok?.textCard[0]?.content}</p>
                </div>
              </div>
            </div>
            <div className="w-full pl-16 mt-12 md:w-6/12 md:mt-0">
              <Image blok={blok?.image} />
            </div>
          </div>
        </Link>
      </div>
    </section>
  ): null;
}
